export default __webpack_public_path__ + "static/media/default_plus.466aee97.svg";